<div class="forum-thread-read-users-modal">
  <div class="mb-4">
    <h4>{{ "GROUPS.LIST.THREAD_READS_MODAL_TITLE" | translate }}</h4>
  </div>

  <div class="forum-thread-read-users-modal__list d-flex flex-column gap-24">
    <div
      *ngFor="let read of reads; trackBy: trackByRead"
      class="d-flex flex-row justify-content-between align-items-center"
    >
      <div class="d-flex flex-row gap-12 align-items-center">
        <div class="forum-thread-read-users-modal__avatar">
          {{
            getUserNameParts(read.user.name).firstName
              | initials: getUserNameParts(read.user.name).lastName
          }}
        </div>

        <div class="d-flex flex-column">
          <h6>
            {{ read.user.name }}
          </h6>
          <p class="text-body-sm color-bg-text-muted">
            {{ read.user.email }}
          </p>
          <p class="text-body-sm color-bg-text-muted d-md-none">
            {{ read.read_at | date: { format: "DD-MM-YYYY HH:mm" } }}
          </p>
        </div>
      </div>

      <p class="text-body-sm color-bg-text-muted d-none d-md-block">
        {{ read.read_at | date: { format: "DD-MM-YYYY HH:mm" } }}
      </p>
    </div>
  </div>
</div>
